<section *ngIf="seoContentInfo?.active" class="seo-content" fxFlex="100">
  <div
    [ngClass]="{
      'top-line': !!seoContentInfo.advisoryContentTitle || !!otherContent.length,
      'seo-content-newStyle': (isNewPLPVariantRestyle$ | async) && isPLP
    }"
    fxFlex="100"
  >
    <app-advisory-content-title
      *ngIf="seoContentInfo.advisoryContentTitle"
      [title]="seoContentInfo.advisoryContentTitle"
    >
    </app-advisory-content-title>
    <div
      [fxFlex]="tableOfContents?.length > 0 ? '60' : '100'"
      fxLayout="column"
      fxFlex.mm-tablet="100"
      fxFlex.mm-mobile="100"
    >
      <app-advisory-content-description
        *ngIf="seoContentInfo.advisoryContentDescription"
        [text]="seoContentInfo.advisoryContentDescription"
      >
      </app-advisory-content-description>
      <div
        [ngClass]="{
          showMobile: displayMobile,
          hideMobile: !displayMobile && isMobileOrTablet && seoContentInfo.advisoryContentDescription
        }"
      >
        <div class="toc__wrapper" id="toc__wrapper" *ngIf="isMobileOrTablet">
          <p class="toc__title">{{ 'CATALOG.CATALOG_PAGE.SEO_CONTENT.TOC' | translate }}</p>
          <ul class="toc__menu" *ngFor="let item of tableOfContents">
            <li class="toc__list">
              <a [ngClass]="{ toc__upperCase: item === 'faq' }" (click)="scroll(item)">
                <mm-icon name="chevron-right" class="toc__icon"></mm-icon> {{ item }}
              </a>
            </li>
          </ul>
        </div>
        <div class="bottom-line" *ngIf="!!seoContentInfo.advisoryContentDescription && !!otherContent.length"></div>
        <app-other-content
          [isSeoContentActive]="seoContentInfo.active"
          [otherContent]="otherContent"
          [source]="source"
          [isTableOfContentVisible]="tableOfContents?.length > 0"
        >
        </app-other-content>
      </div>
      <ng-container *ngIf="isMobileOrTablet && seoContentInfo.advisoryContentDescription && !!otherContent.length">
        <a *ngIf="!displayMobile" class="show-more" (click)="showOnMobile()"
          >{{ 'CATALOG.CATALOG_PAGE.SEO_CONTENT.SHOW_MORE' | translate }}<mm-icon name="chevron-down"></mm-icon
        ></a>
        <a *ngIf="displayMobile" class="show-more less" (click)="hideOnMobile()"
          >{{ 'SHARED.SHOW_LESS.LABEL' | translate }} <mm-icon name="chevron-up"></mm-icon
        ></a>
      </ng-container>
    </div>
    <div
      fxFlex="40"
      *ngIf="!isMobileOrTablet && tableOfContents?.length > 0"
      fxLayout="column"
      fxFlex.mm-tablet="100"
      fxFlex.mm-mobile="100"
    >
      <div
        class="toc__wrapper"
        [ngClass]="{ toc__margin: !seoContentInfo.advisoryContentDescription }"
        id="toc__wrapper"
      >
        <p class="toc__title">{{ 'CATALOG.CATALOG_PAGE.SEO_CONTENT.TOC' | translate }}</p>
        <ul class="toc__menu" *ngFor="let item of tableOfContents">
          <li class="toc__list">
            <a [ngClass]="{ toc__upperCase: item === 'faq' }" (click)="scroll(item)">
              <mm-icon name="chevron-right" class="toc__icon"></mm-icon> {{ item }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
